import { render, staticRenderFns } from "./ItemStockMovement.vue?vue&type=template&id=96896a76&scoped=true"
import script from "./ItemStockMovement.vue?vue&type=script&lang=js"
export * from "./ItemStockMovement.vue?vue&type=script&lang=js"
import style0 from "./ItemStockMovement.vue?vue&type=style&index=0&id=96896a76&prod&scoped=true&lang=css"
import style1 from "./ItemStockMovement.vue?vue&type=style&index=1&id=96896a76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96896a76",
  null
  
)

export default component.exports